import { queryOptions } from '@tanstack/react-query';

import { getSystemUserQuery, getSystemUsersQuery } from './shared';

export const getSystemUserQueryOptions = (id: string) => queryOptions(getSystemUserQuery(id));
export const getSystemUsersQueryOptions = () => queryOptions(getSystemUsersQuery());
